class PlpHeroSection extends HTMLElement {
  constructor () {
    super()

    this.el = this
    this.cards = this.el.querySelector('.js-content-cards')
    this.activeClass = 'show'
    this.showPrevClass = 'show-prev'
    this.showNextButton()

    window.addEventListener('resize', () => {
      this.showNextButton()
    })

    this.cards?.addEventListener('scroll', (e) => {
      this.checkScroll(e.target)
    })
  }

  showNextButton () {
    if (!this.cards) return
    if (this.isOverflowing(this.cards)) {
      this.cards.classList.add(this.activeClass)
    } else {
      this.cards.classList.remove(this.activeClass)
    }
  }

  isOverflowing (element) {
    return element.scrollWidth > element.clientWidth
  }

  checkScroll (element) {
    if (element.scrollLeft + element.clientWidth >= element.scrollWidth) {
      element.classList.remove(this.activeClass)
    } else {
        element.classList.add(this.activeClass)
    }

    element.scrollLeft > 0 ? element.classList.add(this.showPrevClass) : element.classList.remove(this.showPrevClass)
  }

  scrollNext () {
    this.smoothScrollLeft(this.cards, -this.cards.clientWidth)
  }

  scrollPev() {
    this.smoothScrollLeft(this.cards, this.cards.clientWidth)
  }

  smoothScrollLeft (element, distance, duration = 500) {
    const startLeft = element.scrollLeft
    const step = distance / duration
    let startTime

    function stepScroll(timestamp) {
      if (!startTime) startTime = timestamp
      const elapsed = timestamp - startTime
      element.scrollLeft = startLeft - elapsed * step

      if (elapsed < duration) {
        requestAnimationFrame(stepScroll)
      } else {
        element.scrollLeft = startLeft - distance
      }
    }

    requestAnimationFrame(stepScroll)
  }
}

customElements.define('plp-hero-section', PlpHeroSection)
